module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28127",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9401",
      "ably-hubspot-js": "static-2.4436",
      "atom": "static-1.4795",
      "conversations-async-data": "static-2.7385",
      "conversations-error-reporting": "static-1.8601",
      "conversations-internal-pub-sub": "static-1.15687",
      "conversations-internal-schema": "static-1.12368",
      "conversations-message-history": "static-1.11838",
      "conversations-test-sdk": "static-1.10222",
      "conversations-visitor-experience-components": "static-1.21490",
      "head-dlb": "static-1.4754",
      "hs-promise-utils": "static-1.5315",
      "hs-test-utils": "static-1.7709",
      "hubspot-dlb": "static-2.1786",
      "HubStyleTokens": "static-2.11147",
      "I18n": "static-7.1551",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2743",
      "jasmine-runner": "static-1.6180",
      "quartz": "static-1.6613",
      "react-dlb": "static-1.70",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.59",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4199",
      "StyleGuideUI": "static-3.482",
      "transmute": "static-2.85",
      "urlinator": "static-1.4257",
      "usage-tracker": "static-1.7058",
      "usage-tracker-core": "static-1.6908",
      "usage-tracker-public": "static-1.6869",
      "viral-links-lib": "static-1.6748",
      "visitor-ui-component-library": "static-1.5852",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4510",
      "conversations-prop-types": "static-1.7175",
      "conversations-visitor-message-history": "static-1.20227",
      "cssUtils": "static-1.710",
      "enviro": "static-4.387",
      "flux-actions": "static-1.300",
      "foundations-components": "static-1.7368",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5872",
      "hubspot-url-utils": "static-1.3873",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9346",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.349",
      "raven": "static-3.5624",
      "react": "static-7.176",
      "react-aria": "static-1.60",
      "react-dom": "static-7.85",
      "react-redux": "static-7.66",
      "react-rhumb": "static-1.16357",
      "react-utils": "static-2.5106",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7864",
      "signup-constants": "static-1.18253",
      "styled-components": "static-2.84",
      "usage-tracker-multi": "static-1.5472",
      "visitor-ui-component-library-icons": "static-1.5663",
      "hs-promise-rejection-tracking": "static-1.5291",
      "raven-hubspot": "static-1.5931",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3157",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.80",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.76",
      "quartz-config": "static-1.391",
      "quartz-core": "static-1.5832",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4556",
      "foundations-theming": "static-1.4129",
      "UIComponents": "static-3.8094",
      "customer-data-email": "static-1.17551",
      "cv-backend-services": "static-1.1481",
      "immutable-less": "static-1.4378",
      "conversations-skeleton-state": "static-1.6974",
      "crm-events-viz-core": "static-1.32205",
      "customer-agent-discovery-components-lib": "static-1.2266",
      "customer-data-objects": "static-1.7340",
      "icons": "static-2.616",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4332",
      "ui-images": "static-2.1071",
      "HeadJS": "static-2.697",
      "framer-motion": "static-1.66",
      "hs-test-utils-bend-plugin": "static-1.2820",
      "msw": "static-1.39",
      "testing-library": "static-1.146",
      "i18n-data": "static-1.215",
      "moment-timezone": "static-5.77",
      "jasmine": "static-4.4056",
      "history": "static-4.47",
      "signup-ui-url-generator": "static-2.7759",
      "HubStyle": "static-2.11455",
      "quartz-i18n": "static-1.288",
      "sassPrefix": "static-1.150",
      "bend-plugin-foundations-components": "static-1.3637",
      "floating-ui": "static-1.50",
      "foundations-theming-specialty": "static-1.1845",
      "hs-story-utils": "static-1.9151",
      "react-virtualized": "static-2.93",
      "tanstack-table": "static-1.49",
      "trellis-assets": "static-1.1010",
      "ui-fonts": "static-1.409",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3660",
      "usage-tracker-anonymous": "static-1.5475",
      "bender-build-tools": "static-1.2847",
      "dispatcher": "static-1.130",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.778",
      "hubspotter-http": "static-1.4409",
      "mobile-manifest-mixins": "static-1.470",
      "quartz-auth": "static-1.288",
      "quartz-head": "static-1.278",
      "quartz-routing": "static-1.43",
      "quartz-test": "static-1.288",
      "usage-tracker-container": "static-1.7048",
      "bend-plugin-foundations-theming": "static-1.2612",
      "foundations-theming-base": "static-1.3114",
      "stylex": "static-1.26",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4373",
      "customer-data-ui-utilities": "static-1.9549",
      "FileManagerCore": "static-1.38183",
      "FileManagerLib": "static-1.38324",
      "hubspot-apollo-client": "static-1.4604",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.519",
      "timezone-utils": "static-2.4968",
      "ui-gdpr-components": "static-1.10070",
      "ts-schema": "static-1.3835",
      "avatar-components": "static-1.2191",
      "content-assistance-lib": "static-1.7345",
      "crm-component-utils": "static-1.38315",
      "crm-display-components": "static-1.24065",
      "crm-fe-perf": "static-1.22609",
      "crm-links": "static-1.5975",
      "crm-message-bus": "static-1.42149",
      "crm-search-service-types": "static-1.891",
      "crm-source-interpretation-lib": "static-1.5055",
      "customer-data-communicator": "static-1.44723",
      "customer-data-filters-ui": "static-1.38627",
      "customer-data-objects-ui-components": "static-1.12726",
      "customer-data-properties": "static-1.50568",
      "customer-data-rte": "static-1.32286",
      "draft-plugins": "static-2.21173",
      "file-manager-components": "static-1.22684",
      "framework-data-schema-resolvers": "static-1.6592",
      "frontend-preferences-client": "static-1.7649",
      "hubspot-prosemirror": "static-1.17408",
      "object-comments-thread-lib": "static-1.9919",
      "reference-resolvers-lite": "static-1.7814",
      "ui-addon-upgrades": "static-9.17485",
      "universal-associations-select": "static-1.10697",
      "ai-components-ui-library": "static-1.8165",
      "final-form": "static-1.64",
      "ui-addon-video-player": "static-1.8432",
      "inbound-db-properties-service-client": "static-1.3609",
      "property-translator": "static-1.5138",
      "hub-http-shared-msw-handlers": "static-1.9289",
      "hubspotter-http-shared-msw-handlers": "static-1.9287",
      "react-dnd-compat": "static-1.4348",
      "audio-components": "static-1.5509",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35835",
      "immerable": "static-1.3879",
      "ui-universal-auth": "static-1.8599",
      "video-components": "static-1.12349",
      "video-data-lib": "static-1.34004",
      "video-embed": "static-1.34838",
      "hubspot-apollo-cache": "static-1.63",
      "superstore": "static-1.4497",
      "ui-coaching-tips": "static-1.27761",
      "card-properties-lib": "static-1.43337",
      "crm-actions": "static-1.5997",
      "crm-cards-data": "static-1.1088",
      "crm-cards-sdk": "static-1.42714",
      "customer-data-properties-shared-msw-handlers": "static-1.8616",
      "customer-data-property-utils": "static-1.7795",
      "customer-data-tracking": "static-1.6586",
      "inbound-db-meta-service-client": "static-1.3391",
      "framework-data-table": "static-2.11257",
      "location-customization-utils-lib": "static-1.8340",
      "calling-error-reporting": "static-1.31020",
      "calling-internal-common": "static-1.31014",
      "calling-usage-tracker": "static-1.6262",
      "crm_data": "static-4.91003",
      "crm_schema": "static-3.90919",
      "customer-data-content": "static-1.26723",
      "draft-content-plugins": "static-1.27556",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23543",
      "draft-extend": "static-3.69",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.23356",
      "EmailSignatureEditor": "static-1.23808",
      "hubspot-prosemirror-plugins": "static-1.17400",
      "integration-settings-components": "static-1.14587",
      "integrations-lib": "static-1.15196",
      "integrations-tracking-lib": "static-1.5307",
      "native-integrations-shared-strings": "static-1.7513",
      "nav-meta": "static-1.28693",
      "onboarding-scopes": "static-1.6168",
      "outreach-assistant-email-generation": "static-1.5636",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36952",
      "react-colorpicker": "static-2.9936",
      "reference-resolvers": "static-1.7885",
      "rich-text-lib": "static-1.19336",
      "sales-email-signature-service-client": "static-1.3567",
      "sequences-lib": "static-1.7582",
      "ui-addon-i18n": "static-1.10853",
      "ui-addon-iframeable": "static-1.8745",
      "ui-business-units-lib": "static-1.8746",
      "ui-shepherd-react": "static-3.9868",
      "user-context": "static-1.4819",
      "whatsapp-sending-lib": "static-1.4737",
      "customer-data-filters-ui-msw-helpers": "static-1.21062",
      "customer-data-reference-ui-components": "static-1.12863",
      "FormUrlGenerator": "static-2.4455",
      "framework-builder-read-service-client": "static-1.3778",
      "framework-data-schema-quick-fetch": "static-1.6497",
      "multi-account-reference-resolvers": "static-1.692",
      "onboarding-tours": "static-1.16165",
      "reporting-datasets-permissions-lib": "static-1.12843",
      "SharedI18nStrings": "static-1.179",
      "ui-addon-teams": "static-1.21132",
      "calling-global-api": "static-1.63435",
      "calling-lifecycle-internal": "static-1.64817",
      "calling-lifecycle-messages": "static-1.57111",
      "commerce-products-lib": "static-1.8635",
      "conditional-properties-service-client": "static-1.3554",
      "external-options-client-types": "static-1.3914",
      "google-libphonenumber": "static-1.32",
      "hs-entities": "static-1.387",
      "inbounddb-objects-service-types": "static-1.3981",
      "meetings-icalendar-utils-lib": "static-1.358",
      "multi-currency-client-types": "static-1.3449",
      "object-builder-ui-client": "static-1.47748",
      "pipeline-validation-client-types": "static-1.3718",
      "property-value-citations": "static-1.1182",
      "pulse": "static-1.220",
      "smart-property-lib": "static-1.5648",
      "tiered-pricing": "static-1.716",
      "ui-addon-form-validation": "static-1.10719",
      "video-components-external": "static-1.10346",
      "batch-promise": "static-1.1254",
      "crm-pipelines-api-client-types": "static-1.3895",
      "persist-promise": "static-1.3411",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24529",
      "knowledge-content-types": "static-1.8290",
      "payment-link-components": "static-1.22743",
      "ui-addon-emoji-picker": "static-1.9614",
      "call-summary": "static-1.38126",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9435",
      "laboratory-lib": "static-3.6868",
      "merchandise-lib": "static-1.255",
      "purchase-motions-components": "static-1.5362",
      "self-service-api": "static-1.9953",
      "upgrade-management-service-types": "static-1.4232",
      "chatspot-core": "static-1.20063",
      "chirp-fetch": "static-1.1606",
      "ContentUtils": "static-1.67426",
      "copilot-toolkit": "static-1.10353",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "content-icons-ui": "static-1.2130",
      "social-insights-client-types": "static-1.21143",
      "outpost": "static-1.3936",
      "growth-onboarding-feedback-components": "static-1.6310",
      "customer-data-sidebar": "static-2.45234",
      "enrichment-properties-lib": "static-1.14766",
      "customer-data-associations": "static-1.7058",
      "deal-intel-decorators": "static-1.1021",
      "reporting-data": "static-1.66227",
      "tanstack-virtual": "static-1.24",
      "ui-addon-draggable": "static-3.4469",
      "crm-record-cards-service-types": "static-1.3382",
      "crm_universal": "static-1.21549",
      "SalesContentIndexUI": "static-3.8788",
      "signup-ui-lego-core": "static-1.20263",
      "content-embed-lib": "static-1.7065",
      "data-model-builder-lib": "static-1.11462",
      "remote-ui": "static-1.59",
      "ui-components-test-utils": "static-1.5285",
      "ui-extensions-remote-renderer": "static-1.16230",
      "universal-page-editor-lib": "static-1.2720",
      "integrations-error-boundary-lib": "static-1.12611",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10097",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45195",
      "data-token-picker": "static-1.15933",
      "sequences-client-types-lib": "static-1.7439",
      "foundations-components-test-utils": "static-1.4851",
      "magpie-lib": "static-1.5300",
      "navigation-messaging": "static-1.6383",
      "getting-started-shared-tasks": "static-1.17691",
      "getting-started-shared-tasks-store": "static-1.16809",
      "onboarding-tours-utils": "static-1.231",
      "messaging-usage-based-billing-components-lib": "static-1.320",
      "whatsapp-management-lib": "static-1.7896",
      "growth-data-modal": "static-1.5058",
      "growth-onboarding-confetti": "static-1.2776",
      "growth-onboarding-next-action-utils": "static-1.1219",
      "navigation-components": "static-1.17056",
      "onboarding-tours-client": "static-1.4379",
      "ui-shepherd-tracker": "static-1.7249",
      "shared-worker-versioning": "static-1.10742",
      "calling-orchestration-shared-library": "static-1.34587",
      "voice-sms-access-library": "static-1.35",
      "products-iframe-lib": "static-1.7143",
      "products-ui-components-shared-msw-handlers": "static-1.9671",
      "directed-graph": "static-1.660",
      "event-emitter": "static-1.650",
      "breeze-intelligence-kit": "static-1.5215",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9372",
      "fsm": "static-1.3456",
      "policy-lib": "static-1.6525",
      "react-tinymce": "static-1.54438",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53564",
      "tinymce-plugins": "static-1.56678",
      "tinymce-themes": "static-1.55534",
      "content-media-composition-data-lib": "static-1.11204",
      "content-media-compositions": "static-2.15211",
      "idb-keyval": "static-1.38",
      "magpie-types": "static-1.4760",
      "media-bridge-lib": "static-1.18455",
      "commerce-analytics-service-client": "static-1.3414",
      "ui-addon-opt": "static-4.8112",
      "commerce-tours-lib": "static-1.5608",
      "growth-onboarding-reliability": "static-1.4813",
      "sales-checkout-service-client": "static-1.3426",
      "ai-addon-copilot-preview": "static-1.7377",
      "calling-cross-tab-library": "static-1.18986",
      "calling-lifecycle-usage-tracker": "static-1.7964",
      "wootric-nps": "static-1.6694",
      "growth-monetization-service-types": "static-1.4248",
      "nav-client-types": "static-1.2056",
      "purchase-motions-api": "static-1.5365",
      "trials-service-types": "static-1.3649",
      "chatspot-client-types": "static-1.10385",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4531",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2775",
      "card-payment-highlight-lib": "static-1.36322",
      "card-subscription-highlight-lib": "static-1.38687",
      "commerce-billing-lib": "static-1.18294",
      "commerce-contract-lib": "static-1.10916",
      "crm_components": "static-3.91003",
      "invoices-highlight-card-lib": "static-1.53783",
      "orders-highlight-card-lib": "static-1.20710",
      "products-highlight-card-lib": "static-1.16919",
      "project-storage": "static-1.4457",
      "quotes-highlight-card-lib": "static-1.70865",
      "usage-based-billing-components-lib": "static-1.7832",
      "deal-intel-utils": "static-1.1025",
      "reporting-client-types": "static-1.2359",
      "react-flip-move": "static-1.64",
      "FireAlarmUi": "static-1.4256",
      "sales-templates-service-types-lib": "static-1.3924",
      "ui-asset-management-lib": "static-1.10604",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9432",
      "collaboration-sidebar": "static-1.56957",
      "conditional-property-settings-modal": "static-1.11788",
      "data-model-commons-lib": "static-1.11757",
      "feedback-loader": "static-1.28725",
      "html-to-image": "static-1.48",
      "object-definition-builder-lib": "static-1.6784",
      "property-management-iframe": "static-1.12037",
      "property-usages-lib": "static-1.5116",
      "reactflow": "static-1.58",
      "simple-data-table": "static-1.2000",
      "used-in-list-lib": "static-1.6639",
      "visual-association": "static-1.5568",
      "highcharts": "static-8.98",
      "reporting-visualizations": "static-1.58303",
      "ui-extensibility-client-types": "static-1.3676",
      "automation-platform-service-types": "static-1.2467",
      "ContentData": "static-1.67501",
      "email-portal-health-service-types": "static-1.700",
      "marketing-email-service-types": "static-1.1757",
      "reactive-lib": "static-1.450",
      "content-whatsapp-service-types": "static-1.228",
      "marketing-platform-lib": "static-1.6557",
      "short-messages-app-service-client": "static-1.3737",
      "ui-tool-access": "static-1.9867",
      "calling-orchestration-schema": "static-1.34812",
      "sales-views-client-types": "static-1.4018",
      "trellis-story-utils": "static-1.4246",
      "storybook-react": "static-1.27",
      "hub-http-contrib": "static-1.2769",
      "interframe": "static-3.4516",
      "tinymce-data": "static-1.39649",
      "ui-addon-sales-email": "static-1.4937",
      "codemirror": "static-5.89",
      "layout-dnd-components": "static-1.11906",
      "layout-dnd-utils": "static-1.10881",
      "react-codemirror": "static-1.10330",
      "ui-brand-identity-lib": "static-1.13525",
      "NamespacedHubStyle": "static-2.8829",
      "hls.js": "static-1.33",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9107",
      "ai-settings-ui-library": "static-1.7267",
      "copilot-plugins": "static-1.10326",
      "eligibility-engine-service-types": "static-1.2930",
      "commerce-shared-components-lib": "static-1.17747",
      "commerce-subscription-lib": "static-1.36264",
      "commerce-tools-ui-lib": "static-1.9631",
      "usage-tracker-session-replay": "static-1.4744",
      "utility-belt": "static-1.2266",
      "payments-enrollment-embed-lib": "static-1.21698",
      "products-ui-components": "static-1.39154",
      "quotes-ui-lib": "static-1.79583",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6599",
      "invoices-ui-lib": "static-1.53799",
      "commerce-products-api": "static-1.1847",
      "SafeStorage": "static-1.4128",
      "invoices-iframe-lib": "static-1.55857",
      "quotes-modal-lib": "static-1.101540",
      "platform-infra-nav-components": "static-1.7423",
      "reporting-ui-components": "static-2.63499",
      "subscription-experience-data-types": "static-1.14491",
      "association-translator": "static-1.2917",
      "crm-settings-header-lib": "static-1.8031",
      "settings-ui-nav": "static-2.9877",
      "collaboration-sidebar-common": "static-1.1754",
      "crm-properties-common-lib": "static-1.5594",
      "ui-addon-draggable-compat": "static-2.3978",
      "property-management-common": "static-1.4324",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14696",
      "advanced-menus-lib": "static-1.11685",
      "ExportDialog": "static-6.10111",
      "ui-memberships-settings-lib": "static-1.33236",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9206",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13292",
      "highlight.js": "static-1.73",
      "reporting-action-components": "static-1.40461",
      "reporting-snowflake": "static-1.54845",
      "ui-addon-react-router-dom": "static-1.9271",
      "growth-onboarding-empty-states": "static-1.5265",
      "InboxConnectUtils": "static-4.14036",
      "payments-post-enroll-local-storage-lib": "static-1.4814",
      "qrcode-generator": "static-1.63",
      "amplitude-session-replay-browser": "static-1.54",
      "marketplace-ui-apps-core": "static-1.17309",
      "stripe-embedded-components": "static-1.7023",
      "commerce-permissions": "static-1.476",
      "property-description-translator": "static-1.3584",
      "totals-ui-components": "static-1.22809",
      "reporting-plugins": "static-1.9890",
      "reporting-reports": "static-1.65905",
      "edison-service-client-types": "static-1.115",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14695",
      "simple-menus-lib": "static-1.16212",
      "academy-common-lib": "static-1.12752",
      "dashboard-lib": "static-1.80346",
      "share-with-third-party-component-lib": "static-1.8414",
      "developer-experience-shared-components": "static-1.10180",
      "marketplace-ui-client-types": "static-1.16183",
      "marketplace-ui-common": "static-1.18776",
      "ui-addon-integrations-directory-panel": "static-2.7709",
      "stripe-connect-js": "static-1.63",
      "commerce-totals-service-types": "static-1.3570",
      "campaign-roi-lib": "static-1.8079",
      "academy-service-client": "static-1.3383",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3603",
      "oauth-service-types": "static-1.3964",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28127",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9401",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4436",
      "atom": "/atom/static-1.4795",
      "conversations-async-data": "/conversations-async-data/static-2.7385",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8601",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15687",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12368",
      "conversations-message-history": "/conversations-message-history/static-1.11838",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10222",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21490",
      "head-dlb": "/head-dlb/static-1.4754",
      "hs-promise-utils": "/hs-promise-utils/static-1.5315",
      "hs-test-utils": "/hs-test-utils/static-1.7709",
      "hubspot-dlb": "/hubspot-dlb/static-2.1786",
      "HubStyleTokens": "/HubStyleTokens/static-2.11147",
      "I18n": "/I18n/static-7.1551",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2743",
      "jasmine-runner": "/jasmine-runner/static-1.6180",
      "quartz": "/quartz/static-1.6613",
      "react-dlb": "/react-dlb/static-1.70",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.59",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4199",
      "StyleGuideUI": "/StyleGuideUI/static-3.482",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4257",
      "usage-tracker": "/usage-tracker/static-1.7058",
      "usage-tracker-core": "/usage-tracker-core/static-1.6908",
      "usage-tracker-public": "/usage-tracker-public/static-1.6869",
      "viral-links-lib": "/viral-links-lib/static-1.6748",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5852",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4510",
      "conversations-prop-types": "/conversations-prop-types/static-1.7175",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20227",
      "cssUtils": "/cssUtils/static-1.710",
      "enviro": "/enviro/static-4.387",
      "flux-actions": "/flux-actions/static-1.300",
      "foundations-components": "/foundations-components/static-1.7368",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5872",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9346",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.349",
      "raven": "/raven/static-3.5624",
      "react": "/react/static-7.176",
      "react-aria": "/react-aria/static-1.60",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.66",
      "react-rhumb": "/react-rhumb/static-1.16357",
      "react-utils": "/react-utils/static-2.5106",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7864",
      "signup-constants": "/signup-constants/static-1.18253",
      "styled-components": "/styled-components/static-2.84",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5472",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5663",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
      "raven-hubspot": "/raven-hubspot/static-1.5931",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3157",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.76",
      "quartz-config": "/quartz-config/static-1.391",
      "quartz-core": "/quartz-core/static-1.5832",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4556",
      "foundations-theming": "/foundations-theming/static-1.4129",
      "UIComponents": "/UIComponents/static-3.8094",
      "customer-data-email": "/customer-data-email/static-1.17551",
      "cv-backend-services": "/cv-backend-services/static-1.1481",
      "immutable-less": "/immutable-less/static-1.4378",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6974",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32205",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2266",
      "customer-data-objects": "/customer-data-objects/static-1.7340",
      "icons": "/icons/static-2.616",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4332",
      "ui-images": "/ui-images/static-2.1071",
      "HeadJS": "/HeadJS/static-2.697",
      "framer-motion": "/framer-motion/static-1.66",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2820",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.146",
      "i18n-data": "/i18n-data/static-1.215",
      "moment-timezone": "/moment-timezone/static-5.77",
      "jasmine": "/jasmine/static-4.4056",
      "history": "/history/static-4.47",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7759",
      "HubStyle": "/HubStyle/static-2.11455",
      "quartz-i18n": "/quartz-i18n/static-1.288",
      "sassPrefix": "/sassPrefix/static-1.150",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3637",
      "floating-ui": "/floating-ui/static-1.50",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1845",
      "hs-story-utils": "/hs-story-utils/static-1.9151",
      "react-virtualized": "/react-virtualized/static-2.93",
      "tanstack-table": "/tanstack-table/static-1.49",
      "trellis-assets": "/trellis-assets/static-1.1010",
      "ui-fonts": "/ui-fonts/static-1.409",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3660",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5475",
      "bender-build-tools": "/bender-build-tools/static-1.2847",
      "dispatcher": "/dispatcher/static-1.130",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.778",
      "hubspotter-http": "/hubspotter-http/static-1.4409",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.470",
      "quartz-auth": "/quartz-auth/static-1.288",
      "quartz-head": "/quartz-head/static-1.278",
      "quartz-routing": "/quartz-routing/static-1.43",
      "quartz-test": "/quartz-test/static-1.288",
      "usage-tracker-container": "/usage-tracker-container/static-1.7048",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2612",
      "foundations-theming-base": "/foundations-theming-base/static-1.3114",
      "stylex": "/stylex/static-1.26",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4373",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9549",
      "FileManagerCore": "/FileManagerCore/static-1.38183",
      "FileManagerLib": "/FileManagerLib/static-1.38324",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4604",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.519",
      "timezone-utils": "/timezone-utils/static-2.4968",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10070",
      "ts-schema": "/ts-schema/static-1.3835",
      "avatar-components": "/avatar-components/static-1.2191",
      "content-assistance-lib": "/content-assistance-lib/static-1.7345",
      "crm-component-utils": "/crm-component-utils/static-1.38315",
      "crm-display-components": "/crm-display-components/static-1.24065",
      "crm-fe-perf": "/crm-fe-perf/static-1.22609",
      "crm-links": "/crm-links/static-1.5975",
      "crm-message-bus": "/crm-message-bus/static-1.42149",
      "crm-search-service-types": "/crm-search-service-types/static-1.891",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5055",
      "customer-data-communicator": "/customer-data-communicator/static-1.44723",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38627",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12726",
      "customer-data-properties": "/customer-data-properties/static-1.50568",
      "customer-data-rte": "/customer-data-rte/static-1.32286",
      "draft-plugins": "/draft-plugins/static-2.21173",
      "file-manager-components": "/file-manager-components/static-1.22684",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6592",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7649",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17408",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9919",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7814",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17485",
      "universal-associations-select": "/universal-associations-select/static-1.10697",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8165",
      "final-form": "/final-form/static-1.64",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3609",
      "property-translator": "/property-translator/static-1.5138",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9289",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9287",
      "react-dnd-compat": "/react-dnd-compat/static-1.4348",
      "audio-components": "/audio-components/static-1.5509",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35835",
      "immerable": "/immerable/static-1.3879",
      "ui-universal-auth": "/ui-universal-auth/static-1.8599",
      "video-components": "/video-components/static-1.12349",
      "video-data-lib": "/video-data-lib/static-1.34004",
      "video-embed": "/video-embed/static-1.34838",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.63",
      "superstore": "/superstore/static-1.4497",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27761",
      "card-properties-lib": "/card-properties-lib/static-1.43337",
      "crm-actions": "/crm-actions/static-1.5997",
      "crm-cards-data": "/crm-cards-data/static-1.1088",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42714",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8616",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7795",
      "customer-data-tracking": "/customer-data-tracking/static-1.6586",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3391",
      "framework-data-table": "/framework-data-table/static-2.11257",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8340",
      "calling-error-reporting": "/calling-error-reporting/static-1.31020",
      "calling-internal-common": "/calling-internal-common/static-1.31014",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6262",
      "crm_data": "/crm_data/static-4.91003",
      "crm_schema": "/crm_schema/static-3.90919",
      "customer-data-content": "/customer-data-content/static-1.26723",
      "draft-content-plugins": "/draft-content-plugins/static-1.27556",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23543",
      "draft-extend": "/draft-extend/static-3.69",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23356",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23808",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17400",
      "integration-settings-components": "/integration-settings-components/static-1.14587",
      "integrations-lib": "/integrations-lib/static-1.15196",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5307",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7513",
      "nav-meta": "/nav-meta/static-1.28693",
      "onboarding-scopes": "/onboarding-scopes/static-1.6168",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5636",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36952",
      "react-colorpicker": "/react-colorpicker/static-2.9936",
      "reference-resolvers": "/reference-resolvers/static-1.7885",
      "rich-text-lib": "/rich-text-lib/static-1.19336",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3567",
      "sequences-lib": "/sequences-lib/static-1.7582",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10853",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8745",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8746",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9868",
      "user-context": "/user-context/static-1.4819",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4737",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21062",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12863",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4455",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3778",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6497",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.692",
      "onboarding-tours": "/onboarding-tours/static-1.16165",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12843",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "ui-addon-teams": "/ui-addon-teams/static-1.21132",
      "calling-global-api": "/calling-global-api/static-1.63435",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64817",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57111",
      "commerce-products-lib": "/commerce-products-lib/static-1.8635",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3554",
      "external-options-client-types": "/external-options-client-types/static-1.3914",
      "google-libphonenumber": "/google-libphonenumber/static-1.32",
      "hs-entities": "/hs-entities/static-1.387",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3981",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.358",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3449",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47748",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3718",
      "property-value-citations": "/property-value-citations/static-1.1182",
      "pulse": "/pulse/static-1.220",
      "smart-property-lib": "/smart-property-lib/static-1.5648",
      "tiered-pricing": "/tiered-pricing/static-1.716",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10719",
      "video-components-external": "/video-components-external/static-1.10346",
      "batch-promise": "/batch-promise/static-1.1254",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3895",
      "persist-promise": "/persist-promise/static-1.3411",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24529",
      "knowledge-content-types": "/knowledge-content-types/static-1.8290",
      "payment-link-components": "/payment-link-components/static-1.22743",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9614",
      "call-summary": "/call-summary/static-1.38126",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9435",
      "laboratory-lib": "/laboratory-lib/static-3.6868",
      "merchandise-lib": "/merchandise-lib/static-1.255",
      "purchase-motions-components": "/purchase-motions-components/static-1.5362",
      "self-service-api": "/self-service-api/static-1.9953",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4232",
      "chatspot-core": "/chatspot-core/static-1.20063",
      "chirp-fetch": "/chirp-fetch/static-1.1606",
      "ContentUtils": "/ContentUtils/static-1.67426",
      "copilot-toolkit": "/copilot-toolkit/static-1.10353",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "content-icons-ui": "/content-icons-ui/static-1.2130",
      "social-insights-client-types": "/social-insights-client-types/static-1.21143",
      "outpost": "/outpost/static-1.3936",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6310",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45234",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14766",
      "customer-data-associations": "/customer-data-associations/static-1.7058",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1021",
      "reporting-data": "/reporting-data/static-1.66227",
      "tanstack-virtual": "/tanstack-virtual/static-1.24",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4469",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3382",
      "crm_universal": "/crm_universal/static-1.21549",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8788",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20263",
      "content-embed-lib": "/content-embed-lib/static-1.7065",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11462",
      "remote-ui": "/remote-ui/static-1.59",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5285",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16230",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2720",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12611",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10097",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45195",
      "data-token-picker": "/data-token-picker/static-1.15933",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7439",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4851",
      "magpie-lib": "/magpie-lib/static-1.5300",
      "navigation-messaging": "/navigation-messaging/static-1.6383",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17691",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16809",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.231",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.320",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7896",
      "growth-data-modal": "/growth-data-modal/static-1.5058",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2776",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1219",
      "navigation-components": "/navigation-components/static-1.17056",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4379",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7249",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10742",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34587",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.35",
      "products-iframe-lib": "/products-iframe-lib/static-1.7143",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9671",
      "directed-graph": "/directed-graph/static-1.660",
      "event-emitter": "/event-emitter/static-1.650",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5215",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9372",
      "fsm": "/fsm/static-1.3456",
      "policy-lib": "/policy-lib/static-1.6525",
      "react-tinymce": "/react-tinymce/static-1.54438",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53564",
      "tinymce-plugins": "/tinymce-plugins/static-1.56678",
      "tinymce-themes": "/tinymce-themes/static-1.55534",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11204",
      "content-media-compositions": "/content-media-compositions/static-2.15211",
      "idb-keyval": "/idb-keyval/static-1.38",
      "magpie-types": "/magpie-types/static-1.4760",
      "media-bridge-lib": "/media-bridge-lib/static-1.18455",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3414",
      "ui-addon-opt": "/ui-addon-opt/static-4.8112",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5608",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4813",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3426",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7377",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18986",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7964",
      "wootric-nps": "/wootric-nps/static-1.6694",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4248",
      "nav-client-types": "/nav-client-types/static-1.2056",
      "purchase-motions-api": "/purchase-motions-api/static-1.5365",
      "trials-service-types": "/trials-service-types/static-1.3649",
      "chatspot-client-types": "/chatspot-client-types/static-1.10385",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4531",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2775",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36322",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38687",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18294",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10916",
      "crm_components": "/crm_components/static-3.91003",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53783",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20710",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16919",
      "project-storage": "/project-storage/static-1.4457",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70865",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7832",
      "deal-intel-utils": "/deal-intel-utils/static-1.1025",
      "reporting-client-types": "/reporting-client-types/static-1.2359",
      "react-flip-move": "/react-flip-move/static-1.64",
      "FireAlarmUi": "/FireAlarmUi/static-1.4256",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3924",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10604",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9432",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56957",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11788",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11757",
      "feedback-loader": "/feedback-loader/static-1.28725",
      "html-to-image": "/html-to-image/static-1.48",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6784",
      "property-management-iframe": "/property-management-iframe/static-1.12037",
      "property-usages-lib": "/property-usages-lib/static-1.5116",
      "reactflow": "/reactflow/static-1.58",
      "simple-data-table": "/simple-data-table/static-1.2000",
      "used-in-list-lib": "/used-in-list-lib/static-1.6639",
      "visual-association": "/visual-association/static-1.5568",
      "highcharts": "/highcharts/static-8.98",
      "reporting-visualizations": "/reporting-visualizations/static-1.58303",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3676",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2467",
      "ContentData": "/ContentData/static-1.67501",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.700",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1757",
      "reactive-lib": "/reactive-lib/static-1.450",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.228",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6557",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3737",
      "ui-tool-access": "/ui-tool-access/static-1.9867",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34812",
      "sales-views-client-types": "/sales-views-client-types/static-1.4018",
      "trellis-story-utils": "/trellis-story-utils/static-1.4246",
      "storybook-react": "/storybook-react/static-1.27",
      "hub-http-contrib": "/hub-http-contrib/static-1.2769",
      "interframe": "/interframe/static-3.4516",
      "tinymce-data": "/tinymce-data/static-1.39649",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4937",
      "codemirror": "/codemirror/static-5.89",
      "layout-dnd-components": "/layout-dnd-components/static-1.11906",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10881",
      "react-codemirror": "/react-codemirror/static-1.10330",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13525",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8829",
      "hls.js": "/hls.js/static-1.33",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9107",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7267",
      "copilot-plugins": "/copilot-plugins/static-1.10326",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2930",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17747",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36264",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9631",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4744",
      "utility-belt": "/utility-belt/static-1.2266",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21698",
      "products-ui-components": "/products-ui-components/static-1.39154",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79583",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6599",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53799",
      "commerce-products-api": "/commerce-products-api/static-1.1847",
      "SafeStorage": "/SafeStorage/static-1.4128",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55857",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101540",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7423",
      "reporting-ui-components": "/reporting-ui-components/static-2.63499",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14491",
      "association-translator": "/association-translator/static-1.2917",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8031",
      "settings-ui-nav": "/settings-ui-nav/static-2.9877",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1754",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5594",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3978",
      "property-management-common": "/property-management-common/static-1.4324",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14696",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11685",
      "ExportDialog": "/ExportDialog/static-6.10111",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33236",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9206",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13292",
      "highlight.js": "/highlight.js/static-1.73",
      "reporting-action-components": "/reporting-action-components/static-1.40461",
      "reporting-snowflake": "/reporting-snowflake/static-1.54845",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9271",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5265",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14036",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4814",
      "qrcode-generator": "/qrcode-generator/static-1.63",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17309",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7023",
      "commerce-permissions": "/commerce-permissions/static-1.476",
      "property-description-translator": "/property-description-translator/static-1.3584",
      "totals-ui-components": "/totals-ui-components/static-1.22809",
      "reporting-plugins": "/reporting-plugins/static-1.9890",
      "reporting-reports": "/reporting-reports/static-1.65905",
      "edison-service-client-types": "/edison-service-client-types/static-1.115",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14695",
      "simple-menus-lib": "/simple-menus-lib/static-1.16212",
      "academy-common-lib": "/academy-common-lib/static-1.12752",
      "dashboard-lib": "/dashboard-lib/static-1.80346",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8414",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10180",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16183",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18776",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7709",
      "stripe-connect-js": "/stripe-connect-js/static-1.63",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3570",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8079",
      "academy-service-client": "/academy-service-client/static-1.3383",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3603",
      "oauth-service-types": "/oauth-service-types/static-1.3964",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};